import { Box } from "@mui/material";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import LandingPageCarousel from "components/LandingPageCarousel";
import LandingPageClaim from "components/LandingPaceClaim";
import LandingPageCards from "./LandingPageCards";
import LandingPageBPMNPreview from "./LandingPageBPMNPreview";
import LandingPageStats from "./LandingPageStats";
import LandingPageCTA from "./LandingPageCTA";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { noTokenApi } from "api";
import { addMessage } from "Redux/messageReducer";
import LandingPageTemplate from "./templates/LandingPageTemplate";
import { useLocation, useNavigate } from "react-router-dom";

type LandingNavigationState = {
    scrollToSection?: string;
};

export default function LandingPage() {
    const [lang, setLang] = useState('en');
    const [isScrolled, setIsScrolled] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const scrollToSectionId = (location.state as LandingNavigationState | null)?.scrollToSection;

    useEffect(() => {
        (async () => {
            const browserLang = navigator.language.split("-")[0];
            setLang(browserLang);
            const result = await noTokenApi.get(`messages/${browserLang}`);
            document.documentElement.setAttribute("lang", browserLang);
            dispatch(addMessage(result.data.messages));
        })();
    }, [dispatch]);

    useEffect(() => {
        if (!scrollToSectionId) {
            return;
        }

        const timeoutId = window.setTimeout(() => {
            const element = document.getElementById(scrollToSectionId);
            if (!element) {
                return;
            }

            const y = element.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: y, behavior: "smooth" });

            if (!("scrollBehavior" in document.documentElement.style)) {
                window.scrollTo(0, y);
            }

            navigate("/", { replace: true, state: null });
        }, 250);

        return () => window.clearTimeout(timeoutId);
    }, [navigate, scrollToSectionId]);

    return (
        <Box>
            <LandingPageTemplate
                navbar={<Navbar lang={lang} isScrolled={isScrolled} />}
                carousel={<LandingPageCarousel lang={lang} />}
                claim={<LandingPageClaim lang={lang} />}
                cards={<LandingPageCards lang={lang} />}
                bpmnPreview={<LandingPageBPMNPreview lang={lang} />}
                stats={<LandingPageStats lang={lang} />}
                cta={<LandingPageCTA lang={lang} />}
                footer={<Footer lang={lang} />}
            />
        </Box>
    );
}
